import url from './urlList';

/*
 * Dev auth stub — capture/QA affordance ONLY (dev-paywall-mock pattern).
 *
 * Lets the iOS simulator capture lane reach authed screens (exam, results,
 * Detailed Guidance, History) and the OTP UI without real SMS or hand-typed
 * credentials:
 *   - auto-signin: boots a REAL dev-API session from build-time env creds,
 *     so every screen renders live data with production response shapes.
 *   - OTP intercept: /auth/phone/send-otp is answered locally (no SMS) and
 *     /auth/phone/verify-otp accepts DEV_AUTHSTUB_OTP_CODE, fulfilled by the
 *     same real dev-API signin.
 *
 * It can never ride a production binary:
 *   1. every env below is REACT_APP_* build-time — prod build pipelines
 *      don't set them, so the flag compiles to permanently-false;
 *   2. isDevAuthStubEnabled() hard-refuses when the API base resolves to
 *      the production ORIGIN. The check is on the normalized domain itself —
 *      NOT the isProd flag, which localStorage 'emailLogin' can flip while
 *      the domain still points at prod (gate leg GPT-5.6 finding 5).
 */
const PROD_API_HOSTNAME = 'qlearnapi.medlearnity.com';

const resolvesToProdApi = () => {
    try {
        const parsed = new URL(url.domain);
        // Canonicalize before comparing: URL preserves a terminal DNS dot
        // ('qlearnapi.medlearnity.com.'), which resolves to the SAME live
        // host but breaks a literal origin comparison (round-2 finding 4).
        // Any port/path on the prod hostname still counts as prod.
        const hostname = parsed.hostname.replace(/\.+$/, '').toLowerCase();
        return hostname === PROD_API_HOSTNAME;
    } catch {
        // Unparseable domain: fail closed — never enable the stub.
        return true;
    }
};

export const isDevAuthStubEnabled = () => (
    /^(1|true|yes)$/i.test(process.env.REACT_APP_QLEARN_DEV_AUTHSTUB || '') && !resolvesToProdApi()
);

export const DEV_AUTHSTUB_CREDENTIALS = {
    email: process.env.REACT_APP_QLEARN_DEV_AUTHSTUB_EMAIL || '',
    password: process.env.REACT_APP_QLEARN_DEV_AUTHSTUB_PASSWORD || ''
};

// The one-time code the stubbed OTP flow accepts (any other code exercises
// the error UI). Displayed in the capture runbook, not sent anywhere.
export const DEV_AUTHSTUB_OTP_CODE = '000000';

export const DEV_AUTHSTUB_STUB_PHONE = '+15555550100';
